/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */

import React, { useEffect, useState } from 'react';
import { RegularButton, CommonInput, CommonDropdown, ICommonDropdownOption } from 'pg-ui-library';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { Container, ScreenHeader, CardHeader, LeftHeader, RightHeader, PageTitle } from './createStyles';
import { useQuery } from '@tanstack/react-query';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { CellSpan } from './styles';
import { InvoiceStatus } from './enums/invoice-status';
import InvoiceService from 'src/services/invoice.service';
import { NewFiltersInvoice } from './modals/filtersModal';
import { DateTime } from 'luxon';
import { InvoiceListResponse } from 'src/interfaces';
import { TooltipBoxTable, Loader } from 'pg-ui-library';

const InvoiceList: React.FC = () => {
  const [newFilterIsOpen, setNewFilterIsOpen] = useState(false);
  const [filters, setFilters] = useState({
    startDate: null as Date | null,
    endDate: null as Date | null,
    status: '',
    hireType: '',
    showInvocieId: '',
    assignmentId: '',
    clientName: '',
    employeeName: '',
    dateCriteria: '',
    dateFilterType: '',
  });

  const navigate = useNavigate();
  const validationSchema = yup.object({
    subject: yup.string().max(255).required(),
  });

  const myinvocieOptions: ICommonDropdownOption[] = [
    {
      key: '1',
      label: InvoiceStatus.DRAFT.label,
      value: InvoiceStatus.DRAFT.value,
    },
    {
      key: '2',
      label: InvoiceStatus.SUBMITTED.label,
      value: InvoiceStatus.SUBMITTED.value,
    },
    {
      key: '3',
      label: InvoiceStatus.APPROVED.label,
      value: InvoiceStatus.APPROVED.value,
    },
    {
      key: '4',
      label: InvoiceStatus.COMPLETED.label,
      value: InvoiceStatus.COMPLETED.value,
    },
    {
      key: '5',
      label: InvoiceStatus.REJECTED.label,
      value: InvoiceStatus.REJECTED.value,
    },
    {
      key: '6',
      label: InvoiceStatus.BILL_PROCESSED.label,
      value: InvoiceStatus.BILL_PROCESSED.value,
    },
    {
      key: '7',
      label: InvoiceStatus.PAY_PROCESSED.label,
      value: InvoiceStatus.PAY_PROCESSED.value,
    },
  ];

  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Reject: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },

    draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },
    Draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },

    submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },
    Submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },

    approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    Approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    'On Hold': { color: 'default', label: 'Approved', bgColor: '#F9A825' },

    bill_processed: { color: 'default', label: 'Bill Processed', bgColor: '#7b1fa2' }, // purple
    Bill_processed: { color: 'default', label: 'Bill Processed', bgColor: '#7b1fa2' },

    pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' }, // teal
    Pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' },

    completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    resolved: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    Completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
  };

  const allStatusOptions: ICommonDropdownOption[] = Object.values(InvoiceStatus).map((status, index) => ({
    key: String(index),
    label: status.label,
    value: status.value,
  }));

  const { personalInfo } = useTypedSelector(state => state.personalInfo.data);

  const viewInvoice = (row: any) => {
    navigate(`${row.id}`);
  };

  const invoiceColumns: GridColDef[] = [
    {
      headerName: 'ID',
      headerClassName: 'CommonHeaderClass',
      field: 'invoiceShowId',
      minWidth: 120,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => viewInvoice(params.row)}>
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Worker',
      headerClassName: 'CommonHeaderClass',
      field: 'employeeName',
      minWidth: 120,
      sortable: true,
      filterable: false,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents">
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Period Ending',
      headerClassName: 'CommonHeaderClass',
      field: 'periodEnd',
      minWidth: 120,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents">
          {params.value}
        </CellSpan>
      ),
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Company',
      headerClassName: 'CommonHeaderClass',
      field: 'companyName',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Client',
      headerClassName: 'CommonHeaderClass',
      field: 'clientName',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Job Title',
      headerClassName: 'CommonHeaderClass',
      field: 'jobTitle',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Hire Type',
      headerClassName: 'CommonHeaderClass',
      field: 'hireType',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Submitted Amount',
      headerClassName: 'CommonHeaderClass',
      field: 'submittedAmount',
      minWidth: 120,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const amount = params.value;
        const currency = params.row.currency;

        let symbol = '';
        switch (currency) {
          case 'USD':
            symbol = '$';
            break;
          case 'CAD':
            symbol = 'C$';
            break;
          case 'EUR':
            symbol = '€';
            break;
          default:
            symbol = '$';
        }

        return (
          <CellSpan title={`${symbol}${amount}`} data-tag="allowRowEvents">
            {symbol}
            {amount}
          </CellSpan>
        );
      },
    },
    {
      headerName: 'Version',
      headerClassName: 'CommonHeaderClass',
      field: 'version',
      minWidth: 80,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 140,
      renderCell: params => {
        const status = params.value as string;
        const { label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              fontSize: '12px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              borderRadius: '6px',
            }}
          />
        );
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      moduleCategory: '',
      subCatergory: '',
      subject: '',
      description: '',
      priority: '',
      attachments: '',
      searchQuery: '',
      invocieCategory: '',
    },
    validationSchema,
    onSubmit: async (values: any) => {
      try {
        console.log('Form Submitted:', values);
      } catch (error) {
        console.error('Error during form submission', error);
      }
    },
  });

  const CreateInvoice = () => {
    navigate('/invoices/create');
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');

  const companyId = '';
  const [showFun, setShowFun] = useState(true);
  const [userRole] = useLocalStorage('userRole', null);

  useEffect(() => {
    if (userRole === 'external_manager') {
      setShowFun(false);
    } else {
      setShowFun(true);
    }
  }, [userRole]);

  const formatDateForApi = (date: Date | null) => {
    if (!date) return undefined;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  };

  const apiStartDate = formatDateForApi(filters.startDate);
  const apiEndDate = formatDateForApi(filters.endDate);

  const {
    isFetching: isInvocieFetching,
    data: invoiceData,
    refetch: invoiceRefetch,
  } = useQuery<{
    items: InvoiceListResponse[];
    meta: { total: number };
  }>(['invoice-list', page, limit, searchTerm, sortBy, sortDirection, JSON.stringify(filters)], async () => {
    return InvoiceService.getInvoiceList({
      page,
      limit,
      search: searchTerm,
      sortBy,
      sortDirection,
      status: filters.status,
      hireType: filters.hireType,
      showInvocieId: filters.showInvocieId,
      assignmentId: filters.assignmentId,
      clientName: filters.clientName,
      employeeName: filters.employeeName,
      dateCriteria: filters.dateCriteria,
      dateFilterType: filters.dateFilterType,
      startDate: apiStartDate,
      endDate: apiEndDate,
    });
  });

  useEffect(() => {
    invoiceRefetch();
  }, [page, limit, searchTerm, status, invoiceRefetch]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  const onPageMetaChange = (model: any) => {
    setPage(model.page + 1); // API is 1-based
    setLimit(model.pageSize);
  };

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const updateFilters = (
    startDate: Date | null,
    endDate: Date | null,
    selectedCompany: any,
    status: string,
    employmentType: string,
    showInvocieId: string,
    assignmentId: string,
    employmentStatus: string,
    clientName: string,
    hireType: string,
    employeeName: string,
    dateCriteria: string,
    dateRangeType: string
  ) => {
    setPage(1);

    setFilters({
      startDate,
      endDate,
      status,
      hireType,
      showInvocieId,
      assignmentId,
      clientName,
      employeeName,
      dateCriteria: dateCriteria || 'period',
      dateFilterType: dateRangeType,
    });
  };

  const formattedData = invoiceData?.items?.map((row, index) => ({
    ...row,
  }));

  return (
    <Container>
      <NewFiltersInvoice
        isOpen={newFilterIsOpen}
        setIsOpen={setNewFilterIsOpen}
        updateFilters={updateFilters}
        statusOptions={allStatusOptions}
      />
      <ScreenHeader>
        <PageTitle>Search Invoices</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <RegularButton onClick={() => setNewFilterIsOpen(true)}>Filters</RegularButton>

          {showFun && <RegularButton onClick={CreateInvoice}>Create Invoice</RegularButton>}
        </RightHeader>
      </ScreenHeader>
      <CardHeader>
        <LeftHeader></LeftHeader>
      </CardHeader>

      <div>
        {isInvocieFetching ? (
          <div
            style={{
              minHeight: '250px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader />
          </div>
        ) : formattedData?.length ? (
          <DataGrid
            rows={formattedData}
            columns={invoiceColumns}
            pagination
            paginationMode="server"
            paginationModel={{
              page: page - 1,
              pageSize: limit,
            }}
            onPaginationModelChange={onPageMetaChange}
            onSortModelChange={state => {
              onSortMetaChange(state);
            }}
            pageSizeOptions={[10, 20, 50]}
            rowCount={invoiceData?.meta?.total ?? 0}
            disableColumnFilter
            sx={{
              font: '14px Biotif',
              fontWeight: 'bold',
              '& .CommonHeaderClass': {
                color: '#9399B2',
                font: '16px Biotif',
                fontWeight: 'bold',
              },
              minHeight: '150px',
            }}
          />
        ) : (
          <div
            style={{
              minHeight: '100px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            No records found.
          </div>
        )}
      </div>
    </Container>
  );
};

export default InvoiceList;
